export default __webpack_public_path__ + "static/media/Ayubi.5e04fc91.png";